import { track, logError } from '@tracking';
import { NOT_SET } from '@utils/tracking/constants';

export const SCREEN_TYPES = {
  VERTICAL: 'vertical',
  SHOP_DETAIL: 'shop.detail',
};

export const SWIMLANE_TYPES = {
  PARTNER: 'PARTNER',
  PRODUCT: 'PRODUCT',
  NULL_SARCH: 'NULL_SEARCH',
};

export const trackSwimlaneClicked = ({
  shopId,
  swimlaneTitle,
  swimlanePosition,
  swimlaneType = SWIMLANE_TYPES.PRODUCT,
  productSku = NOT_SET,
  positionItem = NOT_SET,
  screenType = SCREEN_TYPES.VERTICAL,
}) => () => {
  const EVENT_NAME = 'swimlane.clicked';

  try {
    const payload = {
      swimlaneTitle,
      swimlanePosition,
      swimlaneType,
      shopId,
      productSku,
      positionItem,
      screenType,
    };

    track(EVENT_NAME, payload);
  } catch (error) {
    logError(EVENT_NAME, error);
  }
};

export default trackSwimlaneClicked;
